export const getModuleMessages = async (locale: ApplicationLocale) => import(`@/modules/admin/locales/${locale}.json`);

export default getModuleMessages;
